<!--
 * @Description: 返回报名成功页
 * @Author: 山淑兰
 * @Date: 2019-12-16 10:41:17
 * @LastEditTime: 2020-07-15 16:22:01
 * @LastEditors: 山淑兰
 -->
<template>
    <div class="foot-nav" v-if="fNavigation.length>0">
        <ul class="fnav">
            <li v-for="(item,index) in fNavigation" :key='index'>
                <a :href="item.navurl" v-if="item.navurl != null">
                    <img :src="item.icon_path">
                    {{ item.title }}
                </a>
                <!-- <a @click="personCenter" v-if="item.navurl == null">
                    <img :src="item.icon_path">
                    {{ item.title }}
                </a> -->
                <a @click="personCenter" v-else-if="item.navurl == null&&item.menucontent=='PERSONALCENTER'" :class="activeShow?'active':''">
                    <img :src="item.icon_path">
                    {{ item.title }}
                </a>
                <a @click="my" v-else-if="item.navurl == null&&item.menucontent=='UserCenter'" :class="activeShow1?'active':''">
                    <img :src="item.icon_path">
                    {{ item.title }}
                </a>
                <a @click="checkInfo" v-else-if="item.navurl == null&&item.menucontent=='CheckInfo'" :class="activeShow2?'active':''">
                    <img :src="item.icon_path">
                    {{ item.title }}
                </a>
                <a v-else>
                    <img :src="item.icon_path">
                    {{ item.title }}
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'navigation',
      data() {
      return {
        fNavigation: '',
        activeShow: false,
        activeShow1: false,
        activeShow2: false
      }
    },
    created() {
        this.footNav()
        this.navActive()
    },
    methods: {
        async footNav() {
            try {
                let params = {
                    m: this.$route.query.m
                }
                let res = await this.$http.Navigation(params)

                this.fNavigation = res.Items
            } catch (err) {
                console.log(err)
            }
        },
        navActive(){
            if (this.$route.path == '/signup/signupinfo') {
                this.activeShow = true
            }else{
                this.activeShow = false
            }
            if (this.$route.path == '/signup/my') {
                this.activeShow1 = true
            }else{
                this.activeShow1 = false
            }
        },
        personCenter() {
            if (this.$route.path == '/signup/modifyInfo') {
                delete this.$route.query.muid
            }
            this.$router.push({
                path: '/signup/signupinfo',
                query: this.$route.query,
            })
            this.activeShow = true
            this.activeShow1 = false
            this.activeShow2 = false
        },
        my(){
            this.$router.push({
                path: '/signup/my',
                query: this.$route.query,
            })
            this.activeShow = false
            this.activeShow1 = true
            this.activeShow2 = false
        },
        checkInfo(){
            this.$router.push({
                path: '/signup/electronicticket',
                query: this.$route.query,
            })
            this.activeShow = false
            this.activeShow1 = false
            this.activeShow2 = true
        },
    },
}
</script>
<style scoped lang="scss">
.foot-nav {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    width: 100%;
    height: 75px;
    padding: 5px 0;
    background: #fff;
    box-shadow: 0px 0px 10px #d3d3d3;

    .fnav {
        width: 100%;
        height: 75px;
        display: flex;
        font-size: 22px;

        li {
            flex: 1;
            text-align: center;
            color: #666;
            border-right: 1px solid #efeef3;

            a {
                color: #666;
                display: block;
                width: 100%;
                height: 100%;
            }
            a.active{
                color: #00439a;
            }
            img {
                display: block;
                width: 40px;
                height: 40px;
                margin: 0 auto;
            }
        }

        li:last-child {
            border-right: none;
        }
    }
}
</style>